module.exports = __webpack_public_path__ + "img/user.a299e60a.svg";